/**
 * Centered loader for full-page or section loading states.
 * Use <Spinner /> for inline (e.g. inside a button) and <PageLoader /> for full sections.
 */
export function Spinner({ className = "" }) {
  return <span className={`spinner ${className}`} role="status" aria-label="Cargando" />;
}

export function PageLoader({ label = "Cargando…", testid }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-16 fade-in"
      data-testid={testid || "page-loader"}
    >
      <span className="spinner spinner-lg" role="status" aria-label="Cargando" />
      <p className="mt-4 text-sm text-slate-500">{label}</p>
    </div>
  );
}

export function SkeletonRow({ height = 12, className = "" }) {
  return (
    <div className={`skeleton ${className}`} style={{ height: `${height}px` }} />
  );
}

export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-5 space-y-3">
      <SkeletonRow height={20} className="w-1/3" />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonRow key={i} height={12} />
      ))}
    </div>
  );
}
